import {
    GET_DONATION_INFO_LOADING, DONATION_DATA_SUCCESS,
    DONATION_DATA_RESET, DONATION_DATA_ERROR
} from "../actions/actionDonation";
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey1 = "donation";

const initialState = {
    donations: loadState(sessionKey1, []),
    loading: false,
    donationError: ''
};

function donationreducer(state = initialState, action) {

    switch (action.type) {
        case GET_DONATION_INFO_LOADING: {
            return {
                ...state,
                loading: true
            };
        }


        case DONATION_DATA_SUCCESS: {

            saveState(sessionKey1, action.payload)

            return {
                ...state,
                donations: action.payload,
                donationError: ''
            };
        }

        case DONATION_DATA_RESET: {

            saveState(sessionKey1, [])

            return {
                ...state,
                donations: [],
                donationError: ''
            };
        }
        
        case DONATION_DATA_ERROR: {

            saveState(sessionKey1, action.payload)

            return {
                ...state,
                loading: false,
                donationError: action.error
            }
        }

        default: {
            return state;
        }
    }
}

export default donationreducer;